import AnimateHeight from 'react-animate-height'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useMemo } from 'react'

import useStyles from './styles'

import { ReactComponent as AngleIcon } from '../../assets/icons/chevron-arrow-down.svg'

const MinimisedSection = ({
  onHeaderClick,
  isOpened = false,
  showToggleButton = true,
  headerContent,
  children,
  className,
  headerClassName,
  hasError = false,
  isFocused,
  toggleWrapperClassName,
  bodyClassName
}) => {
  const height = isOpened ? 'auto' : 0

  const stylesProps = useMemo(() => {
    return { isOpened: !!height, isFocused }
  }, [height, isFocused])

  const classes = useStyles(stylesProps)

  return (
    <section className={classnames(classes.minimizeSection, className, { [classes.hasError]: hasError })}>
      <div className={classnames(classes.header, headerClassName)} onClick={onHeaderClick}>
        {showToggleButton && (
          <div className={classnames(classes.toggleButtonWrapper, toggleWrapperClassName)}>
            <button type="button" className={classnames(classes.toggleButton)}>
              <AngleIcon />
            </button>
          </div>
        )}
        {headerContent && headerContent}
      </div>
      <AnimateHeight duration={300} height={height}>
        <div className={classnames(classes.body, bodyClassName)}>{children}</div>
      </AnimateHeight>
    </section>
  )
}

MinimisedSection.propTypes = {
  onHeaderClick: PropTypes.func,
  isOpened: PropTypes.bool,
  showToggleButton: PropTypes.bool,
  headerContent: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  isFocused: PropTypes.bool,
  toggleWrapperClassName: PropTypes.string,
  hasError: PropTypes.bool
}

export default MinimisedSection
